<template>
    <div style="min-height: 85vh;">
      <div class="uk-position-center">
        <h2>How did we get here</h2>
        <p>Seemed we need to take a step back :)</p>
        <router-link to="/">Back to Home</router-link>

      </div>
    </div>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>
